export default (term: string) => {
  if (typeof term === 'string' && /^\d{5,}$/.test(term)) {
    window.location.href = `/item/by-id/${term}`
    return true
  }
  return false
}
